import * as React from "react";
import { IPatientConcern } from "@curefit/ehr-common";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import * as _ from "lodash";
import {AppConstants} from "../../../utils/AppConstants";
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";

/**
 * Created by prachi on 15/03/18.
 */

let ConcernViewHeaderInfos: ICustomHeaderInfo[] = [
    {label: "trouble", display: "TROUBLE"},
    {label: "lastOccurence", display: "LAST OCCURENCE"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "comment", display: "COMMENTS"},
];


export interface PatientConcernViewProps {
    concerns: IPatientConcern[];
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}

class PatientConcernView extends React.Component<PatientConcernViewProps> {
    render() {
        let showConcerns = this.props.concerns && this.props.concerns.length > 0;
        return (
            <div className="patient-concern-view patient-concern-editor">
                {
                    showConcerns &&
                    <div>
                        {
                            !_.isEmpty(this.props.questionnaire) &&
                            <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
                        }
                        <CustomHeader headerInfos={ConcernViewHeaderInfos} rootCls={"patient-concern"}/>
                        {
                            _.map(this.props.concerns, (item: IPatientConcern, index: number) => {
                                return <div key={`patient-concern-row-${index}`}>
                                    <div className="history-view-row" style={{ width: "100%" }}>
                                        <div className="patient-concern-trouble">
                                            {item.displayValue}
                                        </div>
                                        <div className="patient-concern-lastOccurence">
                                            <div className="lastOccurence-count">
                                                {item.lastOccurence && <span>{item.lastOccurence.count} </span>}
                                                {item.lastOccurence && item.lastOccurence.unit &&
                                                <span>{AppConstants.FrequencyUnit[item.lastOccurence.unit]}</span>}
                                            </div>
                                        </div>
                                        <div className="patient-concern-frequency">
                                            <div className="concern-count">
                                                {item.frequencyCount}
                                                {item.frequencyUnit && <span>/{AppConstants.FrequencyUnit[item.frequencyUnit]}</span>}
                                            </div>
                                        </div>
                                        <div className="concern-editor-comment concern-view-comment">
                                            {item.comment}
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                }
                {!showConcerns && <div style={{color: "grey"}}>No concerns found!</div>}
            </div>
        );
    }
}

export default PatientConcernView